import { AlertVariation } from '@salecycle/ui-component-library';
import { Types as ServiceTypes } from 'services/genericAPIGatewayService';
import { Action as GlobalAction, State as GlobalState } from 'store';
import { Service } from '../services';

export interface Progress {
  status: 'STARTED' | 'COMPLETE' | 'ERROR';
  newApiKey?: string;
  error?: string;
}

interface WizardState {
  groupId?: string;
  groupSkipped?: boolean;
  brandId?: string;
  siteIds?: string[];
  showSkipGroupModal?: boolean;
  stillCreating?: boolean;
  showConfirmationModal?: boolean;
  showHierarchyModal?: boolean;
  errored?: { hasErrored: boolean; title?: string; variation?: AlertVariation; message?: string };
  blocked?: boolean;
}

export interface State extends WizardState {
  progress: {
    [id: string]: Progress;
  };
}

const InitialState: State = {
  siteIds: [],
  errored: { hasErrored: false },
  showSkipGroupModal: false,
  stillCreating: true,
  showConfirmationModal: false,
  showHierarchyModal: undefined,
  groupSkipped: false,
  blocked: false,
  progress: {},
};

enum Types {
  update = 'NewClientWizard:Update',
  clear = 'NewClientWizard:Clear',
}

interface UpdateAction {
  type: Types.update;
  payload: WizardState;
}

interface ClearAction {
  type: Types.clear;
}

export type Action = UpdateAction | ClearAction;

export const Actions = {
  update: (payload: WizardState): Action => ({
    type: Types.update,
    payload,
  }),
  clear: (): Action => ({
    type: Types.clear,
  }),
};

export const Selectors = {
  getBrandId: (state: GlobalState): string => state.clients.wizard.brandId,
  getState: (state: GlobalState): State => state.clients.wizard,
};

export const reducer = (state: State = InitialState, action: GlobalAction): State => {
  switch (action.type) {
    case Types.update: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case Types.clear: {
      return InitialState;
    }

    case ServiceTypes.CREATE_STARTED: {
      if (action.service === Service.Sites || action.service === Service.Brands || action.service === Service.Groups) {
        return {
          ...state,
          progress: {
            ...state.progress,
            [action.payload.id]: {
              status: 'STARTED',
            },
          },
        };
      }
      return state;
    }

    case ServiceTypes.CREATE_COMPLETED: {
      if (action.service === Service.Sites || action.service === Service.Brands || action.service === Service.Groups) {
        return {
          ...state,
          progress: {
            ...state.progress,
            [action.payload.tempId]: {
              status: 'COMPLETE',
              newApiKey: action.payload.id,
            },
          },
        };
      }
      return state;
    }

    case ServiceTypes.CREATE_FAILED: {
      if (action.service === Service.Sites || action.service === Service.Brands || action.service === Service.Groups) {
        return {
          ...state,
          progress: {
            ...state.progress,
            [action.payload.id]: {
              status: 'ERROR',
              error: action.payload.error,
            },
          },
        };
      }
      return state;
    }

    default: {
      return state;
    }
  }
};
